<template>
	<LoginLayout
		form-title="SSO logout"
	>
		<template #form>
			<Message type="info">
				You have been logged out successfully.
			</Message>
			<a @click="$router.push({ name: LOGIN })">
				Log in.
			</a>
		</template>
	</LoginLayout>
</template>
<script>
import LoginLayout from '../../../../shared/layouts/login-layout.vue'
import Message from '../../../../shared/components/message.vue'
import { LOGIN } from '../../router/route-names.js'
export default {
	components: { Message, LoginLayout },
	data () {
		return {
			LOGIN
		}
	}
}
</script>
